import money from '@/services/money';
export default function(VueInstance) {
  VueInstance.filter('money', money);
}
